import { Box } from "@bca/ui-library";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled(Box)`
  border: 2px solid transparent;
  border-top: 2px solid #fff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: ${spin} 2s linear infinite;
`;

export default Spinner;
